import Sidebar from "./Sidebar";
import HelpAssistant from "./HelpAssistant";
import ImpersonateBanner from "./ImpersonateBanner";
import DemoBanner from "./DemoBanner";
import OnboardingTour from "./OnboardingTour";
import NoCreditsModal from "./NoCreditsModal";
import TermsReacceptGate from "./TermsReacceptGate";
import WhatsNewModal from "./WhatsNewModal";
import { SectorPreviewBanner } from "./SectorPreviewSwitcher";
import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

export default function AppShell() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col font-body text-slate-800">
      <DemoBanner />
      <SectorPreviewBanner />
      <div className="flex flex-1 min-h-0">
        <ImpersonateBanner />
        <Sidebar />
        <div className="flex-1 min-w-0 flex flex-col">
          <Outlet />
        </div>
      </div>
      <HelpAssistant />
      <OnboardingTour />
      <NoCreditsModal />
      <TermsReacceptGate />
      <WhatsNewModal />
      <Toaster position="top-right" richColors />
    </div>
  );
}
